// JAIPUR AD FEST 2026 — Content (curated copy + assets)

export const LOGO_URL =
    "/logo.png"; // Placeholder logo URL. Replace with actual asset from design guidelines.

export const EVENT = {
    name: "Jaipur Ad Fest 2026",
    short: "JAF 2026",
    tagline: "A Million Dreams, One Festival",
    subline: "Where creativity, culture & communication become a movement.",
    dates: "3 — 4 October, 2026",
    daysShort: "OCT 03 / 04",
    venue: "Angel Resorts, Jaipur",
    poweredBy: "Powered by RajRox",
    expectedFootfall: "5,000+",
};

export const NAV_SECTIONS = [
    { id: "home", label: "Home", group: "Festival" },
    { id: "about", label: "About", group: "Festival" },
    { id: "expect", label: "What to Expect", group: "Festival" },
    { id: "promoters", label: "Promoters", group: "Festival" },
    { id: "opportunities", label: "Opportunities", group: "Festival" },
    { id: "location", label: "Why Jaipur", group: "Festival" },
    { id: "objectives", label: "Objectives", group: "Experience" },
    { id: "expectations", label: "Expectations", group: "Experience" },
    { id: "highlights", label: "Highlights", group: "Experience" },
    { id: "schedule", label: "Schedule", group: "Experience" },
    { id: "zones", label: "Zones", group: "Experience" },
    { id: "audience", label: "Target Audience", group: "People" },
    { id: "speakers", label: "Speakers", group: "People" },
    { id: "branding", label: "Branding", group: "Partners" },
    { id: "sponsorships", label: "Sponsorships", group: "Partners" },
    { id: "awards", label: "Awards", group: "Spotlight" },
    { id: "layout", label: "Layout", group: "Spotlight" },
    { id: "vision", label: "Vision", group: "Spotlight" },
    { id: "contact", label: "Contact", group: "Spotlight" },
];

// Media assets from design guidelines
export const MEDIA = {
    heroStage:
        "https://static.prod-images.emergentagent.com/jobs/84c9242b-eba8-4c33-a14a-0bc8d408ef2f/images/0e247f9140ae85e133c1687012340b4eabb7da599bf4dc70ec45425f0dc7b875.png",
    abstractBg:
        "https://static.prod-images.emergentagent.com/jobs/84c9242b-eba8-4c33-a14a-0bc8d408ef2f/images/20178ad8cdda902eb28943ce0335c3679e64ca707396c9bd19bb37aef435b882.png",
    trophy: "https://static.prod-images.emergentagent.com/jobs/84c9242b-eba8-4c33-a14a-0bc8d408ef2f/images/d772b326b47b093c64971570e34fe412cea260a958267eb0e9f8f1d5c82857ae.png",
    ticket: "https://static.prod-images.emergentagent.com/jobs/84c9242b-eba8-4c33-a14a-0bc8d408ef2f/images/707f2f8c2b1efa8f4fd5e16b69d6b86cb7e14aadf376a7120bc4f3af4f51664d.png",
    jaipur: "https://images.pexels.com/photos/32261804/pexels-photo-32261804.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    speaker1:
        "https://images.unsplash.com/photo-1612299065617-f883adb67bd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjcmVhdGl2ZSUyMGFkdmVydGlzaW5nJTIwYWdlbmN5JTIwcGVvcGxlfGVufDB8fHx8MTc4MDMwMzEyNHww&ixlib=rb-4.1.0&q=85",
    speaker2:
        "https://images.pexels.com/photos/30004359/pexels-photo-30004359.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// AI-generated clean background images (no text), served from /public/section-bg
export const PDF_BG = {
    hero: "/section-bg/hero.jpg",
    about: "/section-bg/about.jpg",
    expect: "/section-bg/expect.jpg",
    promoters: "/section-bg/promoters.jpg",
    opportunities: "/section-bg/opportunities.jpg",
    location: "/section-bg/location.jpg",
    objectives: "/section-bg/objectives.jpg",
    expectations: "/section-bg/expectations.jpg",
    highlights: "/section-bg/highlights.jpg",
    schedule: "/section-bg/schedule.jpg",
    zones: "/section-bg/zones.jpg",
    audience: "/section-bg/audience.jpg",
    speakers: "/section-bg/speakers.jpg",
    branding: "/section-bg/branding.jpg",
    sponsors: "/section-bg/sponsors.jpg",
    awards: "/section-bg/awards.jpg",
    layout: "/section-bg/layout.jpg",
    vision: "/section-bg/vision.jpg",
    contact: "/section-bg/contact.jpg",
};

export const ABOUT = {
    eyebrow: "About The Festival",
    title: "India's most ambitious advertising, media & creator festival.",
    body: [
        "Jaipur Ad Fest 2026 is a two-day cultural rebellion — a stage built for the people who write the future of advertising, branding, PR, films, and the creator economy in India.",
        "Set inside the Pink City — a place where heritage meets hyper-modernity — JAF is built to be a movement. Not a conference. A movement that converges 5,000+ minds across brands, agencies, creators, media, and technology to spark new ideas, new partnerships, and new commerce.",
    ],
    stats: [
        { value: "5,000+", label: "Attendees" },
        { value: "200+", label: "Speakers & Mentors" },
        { value: "50+", label: "Brand Activations" },
        { value: "2", label: "Game-changing Days" },
    ],
};

export const WHAT_TO_EXPECT = [
    // {
    //     title: "Keynotes & Fireside Chats",
    //     copy: "Unfiltered conversations with India's most decorated creative leaders, agency heads & founders.",
    //     span: "col-span-12 md:col-span-7",
    // },
    // {
    //     title: "Masterclasses",
    //     copy: "Closed-door deep dives into storytelling, AI, brand strategy & culture-building.",
    //     span: "col-span-12 md:col-span-5",
    // },
    // {
    //     title: "Live Creative Battles",
    //     copy: "Watch the country's sharpest minds pitch, design & defend ideas in real time.",
    //     span: "col-span-12 md:col-span-5",
    // },
    // {
    //     title: "AI Experience Zones",
    //     copy: "Hands-on labs to play with the tools defining the next decade of advertising.",
    //     span: "col-span-12 md:col-span-7",
    // },


    {
        title: "Workshops",
        copy: "Hands-on learning with industry experts.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Masterclasses",
        copy: "Closed-door deep dives into storytelling, AI, brand strategy & culture-building.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Networking Sessions",
        copy: "Connect, collaborate and build meaningful relationships",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Creator Meetups",
        copy: "Engage with creators, influencers and content pioneers.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Al Experience Zones",
        copy: "Explore the future of creativity, content and intelligent technology.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Live Competitions",
        copy: "Showcase talent and compete on a national platform.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Entertainment Segments",
        copy: "Curated fun, cultural and interactive entertainment.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Industry Panels",
        copy: "Thought-provoking discussions on trends, challenges and the future.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Brand Showcases",
        copy: "Discover innovations, campaigns and brand stories that inspire.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Live Performances",
        copy: "Enjoy incredible music, acts and creative performances.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Gala Dinner",
        copy: "An exclusive evening of networking, celebration and recognition.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Interactive Experiences",
        copy: "Immersive activations and engaging experience zones.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Startup Engagement",
        copy: "Meet founders, investors and explore startup collaborations.",
        span: "col-span-12 md:col-span-4",
    },
    {
        title: "Media Collaborations",
        copy: "Engage with media partners and amplify your story.",
        span: "col-span-12 md:col-span-4",
    },
];

export const PROMOTERS = [
    {
        name: "Raj Choudhary",
        image: "/raj.png",
        // role: "Founder & Festival Director",
        bio: "Film producer and creative director with extensive experience in film production, TV commercials, branded shoots, and podcast execution. Known for managing large-scale productions and delivering visually impactful storytelling across platforms.",
    },
    {
        name: "Mann Grover",
        image: "/mann.png",
        // role: "Co-Founder, Strategy",
        bio: "Creative strategist specializing in media liaisoning, brand communication, content strategy, and creative campaign development. Experienced in building impactful collaborations between brands, creators and media platforms.",
    },
    {
        name: "Anita Bahada",
        // role: "Co-Founder, Experience",
        bio: "Filmmaker trained in London with experience across films, music videos, and visual storytelling projects. Brings an international creative perspective with strong expertise in cinematic direction and content production.",
    },
    {
        name: "Prerna Talwar",
        // role: "Co-Founder, Industry",
        bio: "PR and social media professional with strong expertise in digital branding, online audience engagement, and public relations strategy. Experienced in managing brand visibility, influencer outreach and impactful communication campaigns.",
    },
];

export const OPPORTUNITIES = [
    {
        title: "INDUSTRY LANDSCAPE AND MARKET OPPORTUNITY",
        copy: "India's advertising, media, marketing & PR industry is valued at *1.5+ lakh crore and growing at 12-15% annually. A massive and expanding market with global potential.",
    },
    {
        title: "CREATOR ECONOMY GROWTH",
        copy: "India has 20M+ digital creators with the creator economy expected to reach $1.2B+ by 2026. A new wave of content innovation and storytelling.",
    },
    {
        title: "INFLUENCER MARKETING",
        copy: "The influencer marketing industry in India is projected to reach ₹3,375 crore by 2026. Brands are rapidly shifting budgets to creator-led campaigns.",
    },
    {
        title: "DIGITAL CONTENT CONSUMPTION",
        copy: "India has 750M+ internet users with video content consumption growing at 25% YoY. OTT, short-form videos, podcasts and digital media are booming.",
    },
    {
        title: "AI-DRIVEN MARKETING",
        copy: "Al is transforming advertising, content creation, personalization and consumer targeting. Brands are investing heavily in Al-powered marketing solutions.",
    },
    {
        title: "RAJASTHAN PRODUCTION ECOSYSTEM",
        copy: "Rajasthan offers world-class locations, skilled talent, cost advantages and a supportive government for film, media and events. Jaipur is emerging as a creative and production hub.",
    },
];

export const LOCATION = {
    eyebrow: "Why Jaipur",
    title: "A 300-year-old capital of culture, now becoming India's creative capital.",
    body: "Jaipur represents the perfect blend of culture, creativity, business, and modern media growth. Known globally for its rich heritage and strong cultural identity, the city is rapidly emerging as a hub for young creators, entrepreneurs, startups, and digital talent. With a growing youth-driven audience, expanding startup ecosystem, increasing tourism influence, and rising demand for film and commercial productions across Rajasthan, Jaipur offers immense creative and business potential for a festival focused on advertising, media, PR, and the creator economy.",
    points: [
        "Cultural Identity",
        "Increasing Youth Population",
        "Tourism Capital",
        "Creative Potential",
        "Emerging Startup Ecosystem",
        "Rajasthan's Growing Production Industry",
        "Prime Operational and Logistical Connectivity across all pincodes at India",
        "Emerging First Choice of Major Film Sectors like Hollywood, Bollywood & Tollywood"
    ],
};

export const OBJECTIVES = [
    {
        n: "01",
        title: "Brands",
        copy: "Create a premier platform for the advertising, media, and marketing industry to connect, learn, and grow.",
    },
    {
        n: "02",
        title: "PR",
        copy: "Celebrate creativity, innovation, and excellence in advertising and communication.",
    },
    {
        n: "03",
        title: "Agencies",
        copy: "Foster collaboration between brands, agencies, creators, startups, media, and technology enablers.",
    },
    {
        n: "04",
        title: "Startups",
        copy: "Inspire the next generation of creative minds and industry leaders.",
    },
    {
        n: "05",
        title: "Entertainment",
        copy: "Promote Jaipur and Rajasthan as a global hub for creativity, production, and business opportunities.",
    },
    {
        n: "06",
        title: "Creators",
        copy: "Drive meaningful conversations on the future of media, advertising, and the creator economy.",
    },
    {
        n: "07",
        title: "Technology",
        copy: "Encourage knowledge sharing through insightful sessions, workshops, and masterclasses.",
    },
    {
        n: "08",
        title: "Media",
        copy: "Recognize and reward impactful work that sets new benchmarks in the industry.",
    },
];

export const EXPECTATIONS = [
    "Two full days of programming across 6+ stages",
    "An unfiltered look at how India's biggest campaigns are made",
    "Live brand challenges & creator collabs on the festival floor",
    "Closed-door investor & founder meet-ups",
    "Award nights celebrating the best work of the year",
    "Networking that actually leads to business",
];

export const HIGHLIGHTS = [
    { value: "5,000+", label: "Attendees expected" },
    { value: "200+", label: "Speakers, Creators & Mentors" },
    { value: "50+", label: "Brand stalls & activations" },
    { value: "6+", label: "Stages running parallel" },
    { value: "20+", label: "Award categories" },
    { value: "2 Days", label: "Pure creative chaos" },
];

export const SCHEDULE = [
    {
        day: "Day 01",
        date: "Friday, 3 October 2026",
        sessions: [
            {
                time: "09:30 AM - 10:30 AM",
                title: "Registration & Welcome Tea",
                type: "Arrival & Networking",
            },
            { time: "10:30 AM - 11:15 AM", title: "Inauguration & Lamp Lighting Ceremony", type: "Opening Ceremony" },
            { time: "11:15 AM - 12:00 PM", title: "Keynote 1: The Future of Creativity", type: "Keynote Session" },
            { time: "12:00 PM - 01:00 PM", title: "Panel 1: Brands, Culture & Influence", type: "Panel Discussion" },
            { time: "01:00 PM - 02:00 PM", title: "Networking Lunch", type: "Networking" },
            { time: "02:00 PM - 03:30 PM", title: "Workshop 1: AI Tools for Creators", type: "Workshop" },
            { time: "03:30 PM - 04:00 PM", title: "Coffee Break & Networking", type: "Networking Break" },
            { time: "04:00 PM - 05:30 PM", title: "Panel 2: Content, Community & Commerce", type: "Panel Discussion" },
            { time: "05:30 PM - 06:30 PM", title: "Fireside Chat: Behind Iconic Campaigns", type: "Fireside Chat" },
            { time: "06:30 PM - 07:00 PM", title: "Awards & Recognitions", type: "Recognition" },
            { time: "07:00 PM - 09:30 PM", title: "Networking Night & Entertainment", type: "Entertainment" },
        ],
    },
    {
        day: "Day 02",
        date: "Saturday, 4 October 2026",
        sessions: [
            { time: "09:30 AM - 10:00 AM", title: "Welcome Tea & Networking", type: "Networking" },
            { time: "10:00 AM - 11:00 AM", title: "Keynote 2: The Creator Economy Era", type: "Keynote Session" },
            { time: "11:00 AM - 12:00 PM", title: "Panel 3: The Future of Digital Storytelling", type: "Panel Discussion" },
            { time: "12:00 PM - 01:00 PM", title: "Workshop 2: Monetization for Creators", type: "Workshop" },
            { time: "01:00 PM - 02:00 PM", title: "Networking Lunch", type: "Networking" },
            { time: "02:00 PM - 03:00 PM", title: "Masterclass: Personal Branding Mastery", type: "Masterclass" },
            { time: "03:00 PM - 04:00 PM", title: "Panel 4: Next Gen Platforms & Opportunities", type: "Panel Discussion" },
            { time: "04:00 PM - 04:30 PM", title: "Coffee Break & Networking", type: "Networking Break" },
            { time: "04:30 PM - 05:30 PM", title: "Creator Showcases & Pitch Session", type: "Showcase" },
            { time: "05:30 PM - 06:00 PM", title: "Closing Ceremony & Vote of Thanks", type: "Closing Ceremony" },
            { time: "06:00 PM - 08:00 PM", title: "Gala Dinner & Entertainment Night", type: "Entertainment" },
        ],
    },
];

export const ZONES = [
    {
        name: "Creator Zone",
        desc: "A dedicated district for India's 20M+ creators. Studios, meetups, brand collabs.",
    },
    {
        name: "Competition Zone",
        desc: "Where the country's sharpest creative minds duel in live, judged battles.",
    },
    {
        name: "Experience Zone",
        desc: "Immersive installations, futuristic displays & brand worlds you can walk inside.",
    },
    {
        name: "Media & Podcast Studio",
        desc: "Live-streamed interviews, podcasts & content desks running across both days.",
    },
    {
        name: "AI Experience Lab",
        desc: "Hands-on stations to play with the tools defining advertising's next chapter.",
    },
    {
        name: "Networking Lounge",
        desc: "VIP hospitality. Quiet rooms. The place where deals actually happen.",
    },
];

export const AUDIENCE = [
    "Brand & Marketing Leaders",
    "Advertising Agencies",
    "PR & Communication Professionals",
    "Content Creators & Influencers",
    "Film & Production Industry",
    "Entrepreneurs & Startup Founders",
    "Media Houses & Journalists",
    "Investors & VCs",
    "Students & Young Creators",
    "Government & Industry Bodies",
    "Entertainment Industry",
    "Technology & AI Companies",
];

export const SPEAKER_CATEGORIES = [
    "ADVERTISING LEADERS",
    "PR EXPERTS",
    "BRAND STRATEGISTS",
    "FILMMAKERS",
    "CREATORS & INFLUENCERS",
    "MEDIA PROFESSIONALS",
    "STARTUP FOUNDERS",
    "ENTERTAINMENT INDUSTRY",
    "MARKETING EXPERTS",
    "GOVERNMENT & INDUSTRY REPRESENTATIVES",
    "CREATIVE BOUTIQUES"
];

export const SPEAKERS = [
    {
        id: "speaker-01",
        photo_url: "",
        featured: true,
        name: "Reveal #1 - Coming Soon",
        role: "Global Creative Officer - Top-tier Network",
        company: "TBA",
        bio: "A name the industry has been waiting for. Lineup reveals begin Q2 2026.",
        category: "Keynote",
    },
    {
        id: "speaker-02",
        photo_url: "",
        featured: true,
        name: "Aarav Mehta",
        role: "Chief Creative Officer",
        company: "Spark & Co. (Placeholder)",
        bio: "Three Cannes Lions. Two Effies. One mission - make Indian advertising globally undeniable.",
        category: "Keynote",
    },
    {
        id: "speaker-03",
        photo_url: "",
        featured: false,
        name: "Priya Sharma",
        role: "VP - Brand & Marketing",
        company: "Atlas Consumer (Placeholder)",
        bio: "Built a Rs 1,200 Cr challenger brand from zero. Lives at the intersection of culture and category.",
        category: "Brand",
    },
    {
        id: "speaker-04",
        photo_url: "",
        featured: false,
        name: "Karan Joshi",
        role: "Founder & Director",
        company: "Studio Nine Films (Placeholder)",
        bio: "Films, TVCs, music videos. The eye behind some of India's most awarded campaigns.",
        category: "Film",
    },
    {
        id: "speaker-05",
        photo_url: "",
        featured: true,
        name: "Ishita Kapoor",
        role: "Creator - 4.2M followers",
        company: "@ishita.k (Placeholder)",
        bio: "Beauty, fashion, finance - a creator who turned a phone into a media company.",
        category: "Creator",
    },
    {
        id: "speaker-06",
        photo_url: "",
        featured: false,
        name: "Rohan Verma",
        role: "Head of AI Labs",
        company: "Nucleus AI (Placeholder)",
        bio: "Building the tools that will rewrite how advertising gets made - by the people making it.",
        category: "Tech",
    },
    {
        id: "speaker-07",
        photo_url: "",
        featured: false,
        name: "Sneha Patel",
        role: "Managing Director",
        company: "Forge PR (Placeholder)",
        bio: "PR's quiet operator. Worked the rooms where India's biggest brand stories were born.",
        category: "PR",
    },
    {
        id: "speaker-08",
        photo_url: "",
        featured: true,
        name: "Reveal #2 - Coming Soon",
        role: "Celebrity Keynote - Bollywood / Industry Icon",
        company: "TBA",
        bio: "A face you know. A voice you trust. A story you've never heard.",
        category: "Keynote",
    },
    {
        id: "speaker-09",
        photo_url: "",
        featured: false,
        name: "Vikram Sinha",
        role: "Founder - Performance Marketing",
        company: "Northpoint Digital (Placeholder)",
        bio: "Rs 500 Cr ad spend under management. The mind behind some of India's loudest D2C launches.",
        category: "Brand",
    },
    {
        id: "speaker-10",
        photo_url: "",
        featured: false,
        name: "Tanya Roy",
        role: "Editor-in-Chief",
        company: "The Mainline (Placeholder)",
        bio: "Long-form journalist turned media founder. Covers the business of attention.",
        category: "Media",
    },
];

export const BRANDING_OPPS = [
    "Stage Branding",
    "Experience Zones",

    "Creator Lounges",
    "Networking Spaces",
    "Media Walls",
    "Award Nights",

    "Digital Integrations",
    "Live Activations",

    "Podcast Studios",
    "Registration Areas",

    "VIP Hospitality",
    "Social Media Visibility",
    "Merchandise",
    "Competition Zones",
    "Workshops"
];

export const BRANDING_OPPS1 = [
    "DIGITAL",
    "EXPERIENTIAL",

    "PRINT",
    "CREATOR ECONOMY",
    "PR & MEDIA",
    "HOSPITALITY",

    "ENTERTAINMENT",
    "SOCIAL AMPLIFICATION",
];

export const SPONSORSHIPS = [
    { tier: "Title Sponsor", note: "The crown. One brand. Two days. Total ownership." },
    { tier: "Powered By Partner", note: "One brand. Two days." },
    { tier: "Co-Sponsors", note: "Premium presence across stages, zones & key moments." },
    { tier: "Associate Partners", note: "Category-exclusive partnerships with deep integration." },
    { tier: "Experience Partners", note: "Power one of the festival's most-talked-about zones." },
    { tier: "Media Partners", note: "Storytelling firepower across print, digital & broadcast." },
    { tier: "Hospitality Partners", note: "Host the VIPs. Define luxury at JAF." },
    { tier: "Community & Support", note: "Be part of the family that makes JAF possible." },
];

export const AWARDS = [
    {
        title: "Creative Excellence",
        desc: "Honoring groundbreaking ideas & outstanding creativity.",
    },
    {
        title: "Brand Impact",
        desc: "Recognizing powerful branding, storytelling & market influence.",
    },
    {
        title: "Best Films & Content",
        desc: "Celebrating exceptional films, videos & digital content.",
    },
    {
        title: "Media Innovation",
        desc: "Awarding excellence in media strategy & innovative campaigns.",
    },
    {
        title: "Creator of the Year",
        desc: "Recognizing creators shaping culture & digital conversations.",
    },
    {
        title: "Agency of the Year",
        desc: "Honoring agencies that set new benchmarks in the industry.",
    },
    {
        title: "Startup Excellence",
        desc: "Celebrating innovative startups driving future growth.",
    },
    {
        title: "Industry Icon Award",
        desc: "Lifetime achievement honor for visionary industry leaders.",
    },
    {
        title: "Young Talent Award",
        desc: "Celebrating emerging talent & future industry stars.",
    },
    {
        title: "Special Jury Awards",
        desc: "Recognizing extraordinary contributions to the industry.",
    },
];

export const VISION = {
    eyebrow: "The Vision",
    title: "Long Term Vision of Jaipur Ad Fest",
    body: "Building India's most influential creative, advertising & cultural communication platform.",
    quote: "Shaping the future of creativity. Connecting India to the world.",
    points: [
        {
            title: "A Global Creative Destination",
            desc: "Position Jaipur as a global hub for creativity, advertising & cultural communication.",
        },
        {
            title: "Industry Leadership",
            desc: "Become India's leading platform for the advertising, branding, media & creator economy.",
        },
        {
            title: "Empowering Creators & Youth",
            desc: "Nurture the next generation of creators, thinkers & storytellers from India & beyond.",
        },
        {
            title: "Strong Industry Collaboration",
            desc: "Build long-term partnerships with brands, agencies, media houses & global industry leaders.",
        },
        {
            title: "Innovation & Future-Ready Ecosystem",
            desc: "Drive innovation in communication, storytelling, technology & immersive experiences.",
        },
        {
            title: "Cultural Storytelling At Scale",
            desc: "Celebrate India's culture, creativity & diversity through powerful storytelling.",
        },
        {
            title: "Global Recognition & Expansion",
            desc: "Expand globally with international collaborations, editions & creative exchange programs.",
        },
        {
            title: "Long-Term Impact",
            desc: "Create a lasting impact on industry, culture, education & the creative economy.",
        },
    ],
    journey: [
        {
            title: "Jaipur",
            desc: "Rooted in Culture. Built on Creativity.",
        },
        {
            title: "India",
            desc: "Empowering the Nation. Inspiring Generations.",
        },
        {
            title: "Global",
            desc: "Connecting Creativity. Shaping the Future.",
        },
    ],
};

export const FAQ = [
    {
        q: "When and where is Jaipur Ad Fest 2026?",
        a: "3rd & 4th October, 2026 at Angel Resorts, Jaipur — Powered by RajRox.",
    },
    {
        q: "Who should attend JAF?",
        a: "Anyone in advertising, PR, media, marketing, films, the creator economy, startups, or tech. From CMOs to college students.",
    },
    {
        q: "Are passes available now?",
        a: "We are opening interest registrations. Early access goes to people on our waitlist — drop your details in the contact form.",
    },
    {
        q: "Can I sponsor or partner with JAF?",
        a: "Yes. Choose from Title, Co-Sponsor, Associate, Experience, Media, Hospitality or Community tiers. Get in touch from the Contact section.",
    },
];

export const CONTACT = {
    email: "hello@jaipuradfest.com",
    phone: "+91 98765 43210",
    address: "RajRox Productions · C-Scheme, Jaipur, Rajasthan, India",
    socials: [
        { name: "Instagram", url: "#" },
        { name: "LinkedIn", url: "#" },
        { name: "YouTube", url: "#" },
        { name: "Twitter", url: "#" },
    ],
};
